<template>
  <button
    :title="$t('sharing.twitter')"
    type="button"
    class="twitter"
    @click="share"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
      image-rendering="optimizeQuality"
      fill-rule="evenodd"
      clip-rule="evenodd"
      viewBox="0 0 512 512"
    >
      <path
        d="M256 0c141.385 0 256 114.615 256 256S397.385 512 256 512 0 397.385 0 256 114.615 0 256 0z"
      ></path>
      <path
        fill="#fff"
        fill-rule="nonzero"
        d="M318.64 157.549h33.401l-72.973 83.407 85.85 113.495h-67.222l-52.647-68.836-60.242 68.836h-33.423l78.052-89.212-82.354-107.69h68.924l47.59 62.917 55.044-62.917zm-11.724 176.908h18.51L205.95 176.493h-19.86l120.826 157.964z"
      ></path>
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  methods: {
    share() {
      this.$store.dispatch('tracking/trackGeneric', {
        category: 'sharing',
        action: 'twitter',
        label: this.text,
      })
      const qs = `text=${encodeURI(this.text)}&url=${encodeURI(this.url)}&via=${
        this.$config.twitterHandle
      }`
      const url = `https://twitter.com/intent/tweet?${qs}`
      window.open(url, '_blank', 'width=500,height=400')
    },
  },
}
</script>
